import { EDA } from "motw_core/Dreams/EDreamAttribute";
import { AreDreamsFiltered } from "../../../Helpers/AreDreamsFiltered";
import { IDreamsState } from "../../../IDreamsState";

export function IsFilteringForDreamAttribute(
    dreamsState: IDreamsState,
    attribute: EDA
) {
    const result =
        AreDreamsFiltered(dreamsState) &&
        dreamsState.selectedAttributes.includes(EDA[attribute]);

    return result;
}
